<div class="my-tickets-container">
  @if (ticketsRequestStatus.isNone) {
    <div class="ticket-sections">
      <h1 class="my-flights-title">Meus voos</h1>

      <!-- Segmented control: picks which of the existing ACTIVE / CANCELLED / INACTIVE maps is rendered. Not sticky. -->
      <div class="status-tabs" role="tablist" aria-label="Filtro de voos">
        @for (tab of statusTabs; track tab.status) {
          <button class="status-tabs__tab" type="button" role="tab"
            [class.status-tabs__tab--selected]="selectedStatus === tab.status"
            [class.status-tabs__tab--cancelled]="tab.status === StatusTicketCard.CANCELLED"
            [attr.aria-selected]="selectedStatus === tab.status"
            [attr.aria-controls]="'status-panel-' + tab.status"
            (click)="selectStatus(tab.status)">
            <span class="status-tabs__label">{{ tab.label }}</span>
            <span class="status-tabs__count">{{ cardCount(tab.status) }}</span>
          </button>
        }
      </div>

      <!-- 1–3 cards: one centred row. From 4 on, a plain grid: each row starts at the left. -->
      <div class="ticket-list" role="tabpanel" [id]="'status-panel-' + selectedStatus"
        [class.ticket-list--centered]="cardCount(selectedStatus) <= 3">
        <!-- The category is part of the track key so cards are recreated (and read their status again) when switching tabs.
             `keyvalue: null` keeps the map order (most recent flight first); the default would sort by PNR code. -->
        @for (ticket of visibleTickets | keyvalue: null; track selectedStatus + '|' + trackByTicketNumber($index, ticket)) {
          <!-- AQUI SE CONTROLA QUE DOS VUELOS ESTEN ASOCIADOS POR PNR  -->
          @if (ticket.value.length == 2) {
            <app-card-ticket-multi
              [ticket1]="ticket.value[0]"
              [ticket2]="ticket.value[1]"
              [status]="selectedStatus">
            </app-card-ticket-multi>
          }
          <!-- AQUI SE CONTROLA QUE 4 VUELOS ESTEN ASOCIADOS POR PNR -->
          @if (ticket.value.length == 4) {
            <app-card-ticket-multi
              [ticket1]="ticket.value[0]"
              [ticket2]="ticket.value[1]"
              [status]="selectedStatus">
            </app-card-ticket-multi>
            <app-card-ticket-multi
              [ticket1]="ticket.value[2]"
              [ticket2]="ticket.value[3]"
              [status]="selectedStatus">
            </app-card-ticket-multi>
          }
          <!-- AQUI SE CONTROLA QUE 3 VUELOS ESTEN ASOCIADOS POR PNR -->
          @if (ticket.value.length == 3) {
            <app-card-ticket-triple
              [ticket1]="ticket.value[0]"
              [ticket2]="ticket.value[1]"
              [ticket3]="ticket.value[2]"
              [status]="selectedStatus">
            </app-card-ticket-triple>
          }
          @if (ticket.value.length == 1) {
            <app-card-ticket
              [ticket]="ticket.value[0]"
              [status]="selectedStatus">
            </app-card-ticket>
          }
        } @empty {
          <p class="ticket-list__empty" role="status">
            @switch (selectedStatus) {
              @case (StatusTicketCard.CANCELLED) { Você não tem voos cancelados. }
              @case (StatusTicketCard.INACTIVE) { Seu histórico de voos está vazio. }
              @default { Você não tem voos ativos. }
            }
          </p>
        }
      </div>
    </div>
  }

  @if (ticketsRequestStatus.isLoading) {
    <app-loading></app-loading>
  }
</div>
